// Whether this hostname puts the storefront at the URL root ("/") or keeps
// it under "/store" — mirrors App.js's isAdminRootHost() exactly (same
// hostname rule), duplicated here rather than imported from App.js so a
// storefront visitor's bundle doesn't pull in the admin CRM's code just for
// one constant — see the code-splitting comment at the top of App.js.
function isAdminRootHost() {
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1' || h.startsWith('crm.');
}

// '' when the storefront owns the root (any hostname except localhost/crm.*)
// — every internal link below becomes `${STORE_BASE}/shop` etc., which
// resolves to a clean "/shop" in that case, or keeps today's "/store/shop"
// on localhost and crm.*.
export const STORE_BASE = isAdminRootHost() ? '/store' : '';

// For the bare home link specifically — STORE_BASE alone is '' at root,
// and an empty path isn't a valid route the same way "/" is.
export const STORE_HOME = STORE_BASE || '/';
